import React, { useContext } from 'react';
import useWindowWidth from 'utils/useWindowWidth';
import SubjectsList from 'views/QuestionsWithCategories/components/SubjectsList';
import Banner from 'views/QuestionsWithCategories/components/Banners/Banner';
import { QuestionApiResponse } from 'types/Questions.types';
import QuestionsList from 'components/QuestionsList';
import styles from 'views/QuestionsWithCategories/QuestionsWithCategories.module.css';
import { configuratorContext } from 'context/ConfiguratorContext';
import VKAd from 'components/VKAd';
import { appAuthContext } from 'context/AuthContext';

type QuestionsWithCategoriesProps = {
  data: QuestionApiResponse | null;
  page: number;
};

const QuestionsWithCategories = ({ data, page }: QuestionsWithCategoriesProps) => {
  const { user } = useContext(appAuthContext);
  const { banners } = useContext(configuratorContext);
  const deviceWidth = useWindowWidth();
  const showDesktopBanner = deviceWidth > 1023 && deviceWidth > 0;

  const itsLastPage = data?.totalPages && +page === data.totalPages;

  return (
    <div className={styles.wrapper}>
      <SubjectsList />
      <main className={styles.content}>
        <div className={styles.container}>
          {data && (
            <QuestionsList
              data={data}
              banner={{
                horizontalBannerPosition: 4,
                eventInfo: 'banner_side_mobile',
              }}
            />
          )}
          <div className={styles.sidebar}>
            {showDesktopBanner && banners?.otvety_side_banners && (
              <Banner
                width={300}
                height={418}
                className={`${styles.banner} ${
                  itsLastPage ? styles.banner__last_page : ''
                }`}
                linkFromBanner={banners?.otvety_side_banners?.link}
                imageUrl={banners?.otvety_side_banners?.images?.desktop}
                bannerType="desktop"
                eventInfo="banner_side"
                bannerName={banners?.otvety_side_banners?.name}
              />
            )}
            {banners?.otvety_side_banners === null &&
              showDesktopBanner &&
              !user?.data?.attributes && (
                <VKAd slotId="1531120" maxWidth="300px" maxHeight="600px" />
              )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default QuestionsWithCategories;
